const html = document.documentElement;
const body = document.body;

megaMenus()
slider()
hideSidebar()

function megaMenus() {
  const megaMenuTriggers = document.querySelectorAll('.mega-menu-trigger');
  const overlayScreen = document.querySelector('.overlay-screen');

  // Function to hide all mega menus and reset their triggers
  function hideAllMenus() {
    const activeMenuTrigger = document.querySelector('.mega-menu-trigger.font-medium');
    if (activeMenuTrigger) {
      const activeMenuName = activeMenuTrigger.getAttribute('data-menu');
      const activeMenu = document.querySelector('.' + activeMenuName);

      activeMenuTrigger.classList.remove('font-medium');
      activeMenu.classList.add('hidden');

      if (activeMenuName === 'mega-menu-topics') {
        const icon = activeMenuTrigger.querySelector('svg');
        icon.classList.remove('rotate-180');
      }
    }
    overlayScreen.classList.add('hidden');
  }

  megaMenuTriggers.forEach(menuTrigger => {
    menuTrigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const menuName = menuTrigger.getAttribute('data-menu');
      const menu = document.querySelector('.' + menuName);

      // Check if the menu is already visible (active)
      const isMenuActive = menuTrigger.classList.contains('font-medium');

      // Hide other menus before showing the clicked menu
      hideAllMenus();

      if (!isMenuActive) {
        overlayScreen.classList.remove('hidden');

        menuTrigger.classList.add('font-medium');
        menu.classList.remove('hidden');

        if (menuName === 'mega-menu-topics') {
          const icon = menuTrigger.querySelector('svg');
          icon.classList.add('rotate-180');
        }
      }
    });
  });

  // Add a click event listener to the body to close the active menu
  document.body.addEventListener('click', (e) => {
    if (!e.target.classList.contains('ghost-search')) {
      hideAllMenus();
    }
  });
}

function slider() {
  const postSlider = document.querySelector('.post-slider');

  if (postSlider) {
    new Flickity('.post-slider', {
      cellAlign: 'left',
      contain: true
    });
  } 
}

function hideSidebar() {
  const isHidden = localStorage.getItem('hideSidebar');
  const hidePostSidebarButton = document.querySelector('.hide-post-sidebar');
  const showPostSidebarButton = document.querySelector('.show-post-sidebar');
  const postSidebar = document.querySelector('.post-sidebar');
  const postSidebarCollapsed = document.querySelector('.post-sidebar-collpased');
  const postContainers = document.querySelectorAll('.post-container');
  const postContent = document.querySelector('.post-content');

  function onHide() {
    postSidebar.classList.add('hidden');
    postSidebarCollapsed.classList.remove('hidden');
    postContent.classList.add('md:!gap-8');

    postContainers.forEach(container => {
      container.classList.add('!justify-center');
    });

    localStorage.setItem('hideSidebar', true);
  }

  function onShow() {
    postSidebar.classList.remove('hidden');
    postSidebarCollapsed.classList.add('hidden');
    postContent.classList.remove('md:!gap-8');

    postContainers.forEach(container => {
      container.classList.remove('!justify-center');
    });

    localStorage.removeItem('hideSidebar');
  }

  if (isHidden) {
    onHide();
  }

  if (hidePostSidebarButton) {
    hidePostSidebarButton.addEventListener('click', () => {
      onHide();
    })
  }

  if (showPostSidebarButton) {
    showPostSidebarButton.addEventListener('click', () => {
      onShow();
    })
  }
}

// ================================
// Infinite Scroll
// ================================
const nextPage = document.getElementById('next');
if (nextPage) {
  const container = nextPage.dataset.container;
  const items = nextPage.dataset.items;

  var infScroll = new InfiniteScroll('.'+container, {
    path: '#next',
    append: '.'+container+' .'+items,
    history: false,
    button: '#loadmore',
    hideNav: '#next',
    scrollThreshold: false
  });

  infScroll.on('append', function(response, path, items) {
    for (var i = 0; i < items.length; i++) {
      reloadSrcsetImgs(items[i]);
    }
  });

  function reloadSrcsetImgs(item) {
    var imgs = item.querySelectorAll('img[srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.outerHTML = img.outerHTML;
    }
  }
}
